import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatIcon } from '@angular/material/icon'
import { MatButton, MatIconButton } from '@angular/material/button'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { PassageiroItemContratoService } from '../../../core/services/passageiro-item-contrato/passageiro-item-contrato.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'

@Component({
  selector: 'logistics-validacao-modal',
  standalone: true,
  imports: [MatProgressBar, MatIcon, MatButton, MatIconButton, TableListComponent],
  templateUrl: './logistics-validacao-modal.component.html',
  styleUrl: './logistics-validacao-modal.component.scss',
})
export class LogisticsValidacaoModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<LogisticsValidacaoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private passageiroItemContratoService: PassageiroItemContratoService,
    private snackbar: SnackbarCustomService,
  ) {}

  loading = false
  validacao: { discrepanciasQuantidade: any[]; discrepanciasTrecho: any[] } | null = null
  validacaoError = false

  quantidadeColumns = [
    { keyColumn: 'servicoDescricao', key: 'servicoDescricao', description: 'Serviço' },
    { keyColumn: 'tipoServicoDescricao', key: 'tipoServicoDescricao', description: 'Tipo de Serviço' },
    { keyColumn: 'dataInicio', key: 'dataInicio', description: 'Data Início' },
    { keyColumn: 'dataFinal', key: 'dataFinal', description: 'Data Final' },
    { keyColumn: 'quantidadeEsperada', key: 'quantidadeEsperada', description: 'Qtd. Pax Esperada' },
    { keyColumn: 'quantidadeAlocada', key: 'quantidadeAlocada', description: 'Qtd. Pax Alocada' },
  ]

  trechoColumns = [
    { keyColumn: 'servicoDescricao', key: 'servicoDescricao', description: 'Serviço' },
    { keyColumn: 'tipoServicoDescricao', key: 'tipoServicoDescricao', description: 'Tipo de Serviço' },
    { keyColumn: 'dataInicio', key: 'dataInicio', description: 'Data Início' },
    { keyColumn: 'dataFinal', key: 'dataFinal', description: 'Data Final' },
    { keyColumn: 'trechoEsperado', key: 'trechoEsperado', description: 'Trecho Esperado' },
    { keyColumn: 'trechoAlocado', key: 'trechoAlocado', description: 'Trecho Alocado' },
  ]

  ngOnInit() {
    this.load()
  }

  load() {
    this.loading = true
    this.validacaoError = false
    this.passageiroItemContratoService.getValidacaoLogistica(this.data.id).subscribe({
      next: (res: any) => {
        this.validacao = res.data ?? res ?? null
      },
      error: () => {
        this.snackbar.error('Não foi possível carregar a validação logística.')
        this.validacaoError = true
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  close() {
    this.dialogRef.close()
  }
}
